import React from 'react';
import { message } from 'antd';

import PaginationBase from '../../../common/base/PaginationBase';

import { PAGINATION, FILTER } from '../../../common/types/paginationType';
import dialog from '../../../common/utility/dialog';
import global from '../../../common/utility/global';

import planContableService from '../../../service/administracion/planContableService';
import tipoPlanContable from '../../../service/administracion/tipoPlanContable';
import tipoCambioService from '../../../service/administracion/tipoCambioService';

import Header from '../../../components/Header';
import Filters from './Filters';
import ResultList from './ResultList';
import FormModal from './FormModal';

export default class Index extends PaginationBase {
    constructor(props) {
        super(props);
        this.props.onSetBreadcrumb();
        this.state = {
            loadingSource: true,
            loadingExcel: false,
            loadingPdf: false,
            padreDisabled: false,
            tipoCuenta: [],
            tiposCambio: [],
            filter: {
                idTipoCuenta: 0,
                nombre: '',
                codigoPadre:0,
                ...FILTER
            },
            pagination: PAGINATION,
            visible: false,
            formValues: this.fetchEmptyFormValues(),
            DataSource: [],
        }
    }

    handleClearFilters = async () => {
        var filter = {
            idTipoCuenta: 0,
            codigoPadre:0,
            nombre: '',
            ...FILTER
        };
        this.setState({ filter });
        this._handlePagination(filter);
    };

    handleKeyUpInput = (e) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            const filter = { ...this.state.filter, ...FILTER };
            this._handlePagination(filter);
        }
    };

    handleChange = (property, value) => {
        const filter = { ...this.state.filter, [property]: value };
        this.setState({ filter });
    };

    handleExportExcel = async () => {
        this.setState({ loadingExcel: true });
        var response = await planContableService.excel(this.state.filter);
        this.setState({ loadingExcel: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Plan de Cuenta.xlsx");
    }

    handleExportPdf = async () => {
        this.setState({ loadingPdf: true });
        var response = await planContableService.pdf(this.state.filter);
        this.setState({ loadingPdf: false });
        if (response !== undefined)
            global.dowloadFile(response.data, "Reporte de Plan de Cuenta.pdf");
    }

    handlePrint = async () => {
        this.setState({ loadingPrint: true });
        var response = await planContableService.pdf(this.state.filter);
        this.setState({ loadingPrint: false });
        if (response !== undefined) {
            var file = window.URL.createObjectURL(response.data);
            var win = window.open(file, '_blank');
            win.focus();
        }
    }

    handleDeleteActive = (values) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;
            if (values.flag)
                response = await planContableService.eliminar(values);
            else
                response = await planContableService.activar(values);

            if (response.status === 200) {
                message.success('Proceso realizado correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };

    /******************** FORM MODAL *****************/

    fetchEmptyFormValues = () => {
        return {
            id: 0,
            elemento: 0,
            codigoCuenta: '',
            codigoPadre:0,
            descripcion: '',
            idTipoCuenta: 0,
            operacionAsociada: '',
            tipoCuenta: [],
        }
    }

    handleNew = () => {
        var formValues = this.fetchEmptyFormValues();
        formValues.tipoCuenta= this.state.tipoCuenta;

        this.setState({ visible: true, formValues });
    };

    handleEdit = async (response) => {
        if (response !== undefined) {

           var item= {
                id: response.id,
                elemento: response.elemento,
                codigoCuenta: response.codigoCuenta,
                codigoPadre:response.codigoPadre,
                descripcion: response.descripcion,
                idTipoCuenta: response.idTipoContable,
                operacionAsociada: response.operacionAsociada,
                tipoCuenta: this.state.tipoCuenta,
            }

            this.setState({ visible: true, formValues: item });
        }
    };

    handleSave = async (values, form) => {
        dialog.confirm("¿Esta seguro de realizar la acción?", async () => {
            var response;

            if (values.id === 0)
                response = await planContableService.registrar(values);
            else
                response = await planContableService.modificar(values);

            if (response.status === 200) {
                form.resetFields();
                this.setState({ visible: false });
                message.success((values.id === 0 ? 'Registrado' : 'Modificado') + ' correctamente.');
                this._handlePagination(this.state.filter);
                return;
            }

            if (response.status === 400) {
                dialog.warning(<ul>{response.data.messages.map(item => (<li key={global.fetchUniqueCode()}>{item}</li>))}</ul>);
                return;
            }

            dialog.error('Ocurrió un error inesperado, por favor vuelva a intentarlo más tarde.');
        });
    };


    
    //#region  "Lista Niveles"

    handleNivel0 = async (isEdit, expanded, item) => {
        if (isEdit > 0) {
            this.handleEdit(item);
        } else {
            this.setState({
                formValues: {
                    ...this.state.formValues,
                    codigoPadre: parseInt(item.codigoCuenta),
                    codigoCuenta: item.codigoCuenta,
                    elemento: item.elemento
                },
                padreDisabled: !expanded
            });
        }
    }

    handleSearchNivel1 = async (isEdit,expanded,item) => {

        if (isEdit > 0) {
            this.handleEdit(item);
            return;
        }
        var filter = this.state.filter;
        filter.codigoPadre=item.codigoCuenta;
       const ListNivel1 = await planContableService.paginacion(filter);

       var dataSource = [];

       this.state.pagination.data.forEach(element => {
           var item = { ...element };
           dataSource.push(item);
       });

       dataSource.forEach(nivel1 => {
            nivel1.listaNivel.forEach(nivel2 => {
                if (nivel2.codigoCuenta === item.codigoCuenta) {
                    nivel2.listaNivel1 = ListNivel1.data;
                    return;
                }
            });
        });

        ListNivel1.data=dataSource;

        this.setState({
            formValues: {
                ...this.state.formValues,
                codigoPadre: parseInt(item.codigoCuenta),
                codigoCuenta:item.codigoCuenta,
                elemento:item.elemento
            },
            pagination: ListNivel1,
            filter: {
                ...this.state.filter,
                codigoPadre:0,
            }
        });
    }

    handleSearchNivel2 = async (isEdit,expanded,item) => {
    
        if (isEdit > 0) {
            this.handleEdit(item);
            return;
        }
        var filter = this.state.filter;
        filter.codigoPadre=item.codigoCuenta;

       const ListNivel2 = await planContableService.paginacion(filter);

       if(ListNivel2!=undefined){
           return false;
       }
         if(ListNivel2.data.length==0){
           return false;
       }

       var dataSource = [];

       this.state.pagination.data.forEach(element => {
           var item = { ...element };
           dataSource.push(item);
       });

       dataSource.forEach(nivel1 => {
            nivel1.listaNivel.forEach(nivel2 => {
                nivel2.listaNivel1.forEach(nivel3 => {
                    if (nivel3.codigoCuenta === item.codigoCuenta) {
                        nivel3.listaNivel2 = ListNivel2.data;
                        return;
                    }
                });
            });
        });

        ListNivel2.data=dataSource;

        this.setState({
            formValues: {
                ...this.state.formValues,
                codigoPadre: parseInt(item.codigoCuenta),
                codigoCuenta:item.codigoCuenta,
                elemento:item.elemento
            },
            pagination: ListNivel2,
            filter: {
                ...this.state.filter,
                codigoPadre:0,
            }
        });
  
    }

    
    handleSearchNivel3 = async (item) => {
    
        var filter = this.state.filter;
        filter.codigoPadre=item.codigoCuenta;

       //const movimientosKardex = await planContableService.paginacion(filter);

       message.success("nivel 3" + item.descripcion)
 
        //this.setState({ DataSource: dataSource });
    }
    //#endregion
    


    //#region "New Noviles"
    handleNewNivel1 = async () => {
        this.setState({
            formValues: {
                ...this.state.formValues,
                tipoCuenta:this.state.tipoCuenta,
                codigoCuenta: this.state.formValues.codigoCuenta,
                codigoPadre: this.state.formValues.codigoPadre,
                elemento:this.state.formValues.elemento
            },
            visible: true
        });



        
    }
    //#endregion

    async componentDidMount() {
        this._initPagination(this.state.filter, planContableService.paginacion);

        const tipoPlan = await tipoPlanContable.listar(); 
        const tiposCambio = await tipoCambioService.listar();

        this.setState({
            loadingSource: false,
            tipoCuenta: tipoPlan ? tipoPlan : [],
            tiposCambio: tiposCambio ? tiposCambio : []
        });
    };

    render() {
        return (
            <div>
                <Header
                    title="Plan  Contable"
                    onNew={this.handleNew}
                    disabled={this.state.padreDisabled}
                    loadingNew={this.state.loadingSource}
                    onSearch={() => this._handlePagination({ ...this.state.filter, ...FILTER })}
                    onClearFilters={this.handleClearFilters}
                />
                <Filters
                    filter={this.state.filter}
                    planesCuenta={this.state.planesCuentaAutocomplete}
                    tipo_PlanContable={this.state.tipoCuenta}
                    onKeyUpSearch={this.handleKeyUpInput}
                    onChange={this.handleChange}
                />
                <ResultList
                    pagination={this.state.pagination}
                    loadingEdit={this.state.loadingSource}
                    loadingExcel={this.state.loadingExcel}
                    loadingPdf={this.state.loadingPdf}
                    loadingPrint={this.state.loadingPrint}
                    onExportExcel={this.handleExportExcel}
                    onExportPdf={this.handleExportPdf}
                    onPrint={this.handlePrint}

                    onDeleteActive={this.handleDeleteActive}
                    onChange={this._handleChangePagination}

                    dataSource={this.state.DataSource}
                    handleNivel0={this.handleNivel0}

                    handleSearchNivel1={this.handleSearchNivel1}
                    handleSearchNivel2={this.handleSearchNivel2}
                    handleSearchNivel3={this.handleSearchNivel3}

                    handleNewNivel1={this.handleNewNivel1}
                    handleNewNivel2={this.handleNewNivel1}
                    handleNewNivel3={this.handleNewNivel1}

                    handleEditNivel={(e)=>{alert(e.codigoCuenta)}}
                />
                <FormModal
                    visible={this.state.visible}
                    formValues={this.state.formValues}
                    onClose={() => this.setState({ visible: false })}
                    onSave={this.handleSave}
                />
            </div>
        );
    }
}  